<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<generic-dialog>
	<div class="fields-area">
		<!-- Client ID -->
		<mat-form-field class="full-width">
			<mat-label>Client ID</mat-label>
			<input matInput type="text" readonly value="{{ data.clientId }}" />
		</mat-form-field>

		<!-- Client secret -->
		<mat-form-field class="full-width">
			<mat-label>Client secret</mat-label>
			<input matInput type="{{ passwordInputType }}" readonly value="{{ data.password }}" />
			<button matSuffix mat-icon-button (click)="togglePasswordVisibility()">
				<mat-icon>visibility</mat-icon>
			</button>
		</mat-form-field>
	</div>
</generic-dialog>
